<template>
  <form novalidate @submit.prevent="updatePassword">
    <LsModal :title="(type + ' account password') | titleCase" track-id="password_modal">
      <template #body>
        <div class="columns">
          <div class="column">
            <LsInput
              v-model="password"
              track-id="password_modal-password"
              placeholder="Enter Password"
              type="password"
              name="password"
              :validation="{ required: true, min: 6 }"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <LsInput
              v-model="password_new"
              track-id="password_modal-password_new"
              placeholder="Re-enter Password"
              type="password"
              name="password_new"
              :validation="{ required: true, min: 6 }"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <LsButton
          type="submit"
          :text="`${type} Password`"
          track-id="password_modal-on_submit"
          :loading="auth.loadingStatus.isUpdating || profile.loadingStatus.isUpdating"
      /></template>
    </LsModal>
  </form>
</template>

<script>
import VueTypes from 'vue-types';
import { LsModal, LsButton, LsInput } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { AUTH__RESET_PASSWORD, PROFILE__UPDATE_PASSWORD } from '@/store/types';
import { lsToastService } from 'ls-vue-common';

export default {
  name: 'PasswordModal',
  components: {
    LsModal,
    LsButton,
    LsInput,
  },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    type: VueTypes.oneOf(['update', 'set', 'reset']).def('update'),
    token: VueTypes.string,
  },
  data() {
    return {
      password: '',
      password_new: '',
    };
  },
  computed: {
    ...mapState(['auth', 'profile']),
  },
  methods: {
    ...mapActions([AUTH__RESET_PASSWORD, PROFILE__UPDATE_PASSWORD]),
    async updatePassword() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }

      // :validation="{ required: true, min: 6, is: password }"
      // ^ this validation logic on the second input was not working in IE
      // so using a modal until we figure out why
      if (this.password !== this.password_new) {
        return lsToastService.open({
          message: 'Passwords do not match',
          type: 'is-error',
        });
      }

      if (this.token) {
        this[AUTH__RESET_PASSWORD]({
          token: this.token,
          password: this.password,
          password_repeat: this.password_new,
          onSuccess: this.$parent.close,
        });
      } else {
        this[PROFILE__UPDATE_PASSWORD]({
          password_new: this.password_new,
          onSuccess: this.$parent.close,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
